export const PACKAGING_SLABS = [
  { max: 49, maxCharge: 5 },
  { max: 150, maxCharge: 7 },
  { max: 300, maxCharge: 10 },
  { max: 500, maxCharge: 15 },
  { max: Infinity, maxCharge: 20 }
];
